export enum ToastType {
	ERROR = 'error',
}
